function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#print_svg__clip0_11928_599)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.36.875V.75H3.64v.125L3.639 3.26H-.125v8.721h2.51V17h11.23v-5.02h2.51V3.26H12.36V.875zm-1.725 12.55v-.126h-5.27v1.192h5.27v-1.067zm0-2.51v-.125h-5.27V11.98h5.27V10.915zm2.98-.125V8.28H2.385v2.51l-1.319-.001V4.451h13.868v6.338h-1.32zm-10.04 5.02V9.47h8.849v6.34H3.575zM4.831 3.26V1.942h6.338V3.26H4.83z",
  fill: "#D44400",
  stroke: "#D44400",
  strokeWidth: 0.25
}));
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "print_svg__clip0_11928_599"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .875)",
  d: "M0 0h16v16H0z"
})));
function SvgPrint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 17",
    fill: "none"
  }, props), _ref, _ref2);
}
export default SvgPrint;